var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getGlobalSpinnerShow)?_c('b-row',{staticClass:"global-spinner-container",attrs:{"align-v":"center","align-h":"center"}},[_c('div',{attrs:{"id":"spinnerContainer"}},[_c('img',{attrs:{"src":"/static/img/loading.gif"}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-caf30736","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/GlobalSpinner.vue
// module id = null
// module chunks = 